import type { Route } from "./+types/podcast";
import Page from "../pages/Video";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.podcasts() }; }
export const meta = () => pageMeta({ title: "Gazar Breakpoint | Podcast", description: "Gazar Breakpoint -- weekly deep dives into system design, architecture decisions, and the senior-to-staff gap.", path: "/podcast", image: OG_IMAGE.podcast });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
